import React,{useEffect, useState} from 'react';
import InputField from '../../../../common/InputField';
import SelectOption from '../../../../common/SelectOption';
import { useDispatch, useSelector } from 'react-redux';
import AutoCompete from '../../../../common/AutoCompleteField';
import RadioButton from '../../../../common/RadioButton';
import CommonCheckBox from '../../../../common/CommonCheckBox';
import useInputValidator from '../../../../../hooks/useInputValidator';
import SpecialAmenities from '../Addons/Addon';
import { Form } from 'antd';
import {BOOKING_TYPE} from "../../../../common/constants";

const Amenities = ({ name, selectedPricingOptions, form ,activity, category }) => {
  const { value, handleChange } = useInputValidator({});
  const amenities = useSelector(state => state.space?.amenities?.data?.amenities || []);
  const paymentOptions = useSelector((state) => state.space?.paymentOptions?.data?.filter(i => i.name === 'Monthly')|| []);
  const [bookingType, setBookingType ] = useState(BOOKING_TYPE)

  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!'
    }
  ];

  useEffect(() => {
    const isMonthlySelected = selectedPricingOptions?.map(i => i === paymentOptions[0].id).filter(value => value == true);
    // if (isMonthlySelected?.[0] || activity=='WORK_PRIV') {
    //   const type = bookingType.filter((option => { return option.boolValue === false }));
    //   setBookingType(type);
    // } else {
    //   setBookingType(BOOKING_TYPE);
    // };
    if (form?.getFieldsValue('instanceBookingAvailability')===true && isMonthlySelected?.[0] ) {
      form.setFieldsValue({
        instanceBookingAvailability: null
      })
    }
  }, [selectedPricingOptions])

  return (
    <>
      <SelectOption
        isMultiple={false}
        name={'instanceBookingAvailability'}
        placeholder={'Select Booking Type'}
        rules={[
          {
            required: true
          }
        ]}
        label={'Booking Type'}
        values={bookingType}
        labelName={'name'}
        valueName={'boolValue'}
      />

      {category === 'Meet' &&
        <SelectOption 
          isMultiple={true}
          values={amenities}
          name={name}
          label={'Amenities'}
          labelName={'name'}
          valueName={'id'}
        />
      }
      {/* <CommonCheckBox name={['amenities', 'wifi']} label={'Wifi'} handleOnChange={null} />
      <CommonCheckBox
        name={['amenities', 'airConditioning']}
        label={'Air Conditioning'}
        handleOnChange={null}
      />
      <CommonCheckBox
        name={['amenities', 'kitchen']}
        label={'Kitchen/Pantry'}
        handleOnChange={e => handleChange('kitchen', e.target.checked)}
      />
      <CommonCheckBox name={['amenities', 'cafe']} label={'Cafe'} handleOnChange={null} />
      <CommonCheckBox
        name={['amenities', 'teaCoffee']}
        label={'Tea/Coffee'}
        handleOnChange={null}
      />
      <CommonCheckBox name={['amenities', 'water']} label={'Water'} handleOnChange={null} />
      <CommonCheckBox
        name={['amenities', 'allDayAccess']}
        label={'24/7 Access'}
        handleOnChange={null}
      />
      {category === 'Work' && (
        <CommonCheckBox
          name={['amenities', 'mailLocker']}
          label={'Mail Locker'}
          handleOnChange={e => handleChange('mailLocker', e.target.checked)}
        />
      )}
      {category === 'Work' && (
        <CommonCheckBox
          name={['amenities', 'printing']}
          label={'Printing'}
          handleOnChange={e => handleChange('printing', e.target.checked)}
        />
      )}
      {category === 'Work' && (
        <CommonCheckBox
          name={['amenities', 'meetingRoom']}
          label={'Meeting Room'}
          handleOnChange={e => handleChange('meetingRoom', e.target.checked)}
        />
      )}
      {(category === 'Meet' || category === 'Train') && (
        <CommonCheckBox
          name={['amenities', 'whiteboard']}
          label={'Whiteboard'}
          handleOnChange={e => handleChange('whiteboard', e.target.checked)}
        />
      )}
      {(category === 'Meet' || category === 'Train') && (
        <CommonCheckBox
          name={['amenities', 'videoConferencing']}
          label={'Video Conferencing'}
          handleOnChange={e => handleChange('videoConferencing', e.target.checked)}
        />
      )}
      {(category === 'Meet' || category === 'Train') && (
        <CommonCheckBox
          name={['amenities', 'projector']}
          label={'Projector'}
          handleOnChange={e => handleChange('projector', e.target.checked)}
        />
      )}

      {(category === 'Meet' || category === 'Train') && (
        <CommonCheckBox
          name={['amenities', 'mic']}
          label={'Mic'}
          handleOnChange={e => handleChange('airConditioning', e.target.checked)}
        />
      )}
      {(category === 'Meet' || category === 'Train') && (
        <CommonCheckBox
          name={['amenities', 'soundSystem']}
          label={'Sound System'}
          handleOnChange={e => handleChange('soundSystem', e.target.checked)}
        />
      )}

      {addons.map((addon, index) => (
        <Form.Item label={addon} name={['amenities', 'addOns', index]}>
          <SpecialAmenities />
        </Form.Item>
      ))}

      <CommonCheckBox
        name={['rules', 'childrenUnder12']}
        label={'children Under 12'}
        handleOnChange={null}
      />
      <CommonCheckBox
        name={['rules', 'externalCatering']}
        label={'External catering'}
        handleOnChange={null}
      />
      <CommonCheckBox name={['rules', 'cooking']} label={'Cooking'} handleOnChange={null} />
      <CommonCheckBox name={['rules', 'music']} label={'Music'} handleOnChange={null} />
      <CommonCheckBox name={['rules', 'loudMusic']} label={'Loud Music'} handleOnChange={null} />
      <CommonCheckBox
        name={['rules', 'sellingAlcohol']}
        label={'Selling Alcohol'}
        handleOnChange={null}
      />
      <CommonCheckBox
        name={['rules', 'servingAlcohol']}
        label={'servingAlcohol'}
        handleOnChange={null}
      />
      <CommonCheckBox name={['rules', 'smoking']} label={'Smoking'} handleOnChange={null} />
      <CommonCheckBox name={['rules', 'ticketSales']} label={'ticketSales'} handleOnChange={null} />
      <CommonCheckBox name={['rules', 'pets']} label={'Pets'} handleOnChange={null} /> */}
    </>
  );
};

export default Amenities;
